import React, { useCallback, useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { submitBureauForm } from 'src/store/actions/bureauFormActions';
import { useDispatch, useSelector } from 'react-redux';
import CircularStepper from 'src/components/FormStepper/CircularStepper';
import {
  selectBureauFormResult,
  selectBureauFormTokenValidationStatus
} from 'src/store/selectors/bureauFormSelectors';
import { selectAdminPhonesParameter } from 'src/store/selectors/parameterSelector';
import { loadAdminNumbers } from 'src/store/actions/parameterActions';
import makeInitialState from './initialState';
import CurrentStep from './CurrentStep';
import ResultBureauView from '../ResultViews/resultViews';

const stepperLabels = [
  { label: 'BUREAU_FORM.STEPS_ZERO' },
  { label: 'BUREAU_FORM.STEPS_ONE' },
  { label: 'BUREAU_FORM.STEPS_TWO' },
  { label: 'BUREAU_FORM.STEPS_THREE' },
  { label: 'BUREAU_FORM.STEPS_FOUR' },
  { label: 'BUREAU_FORM.STEPS_FIVE' },
  { label: 'BUREAU_FORM.STEPS_SIX' }
];

const BureauForm = () => {
  const initialState = makeInitialState();
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [data, setData] = useState(initialState);
  const [labels, setLabels] = useState(stepperLabels);
  const buroResponse = useSelector(selectBureauFormResult);
  const adminPhoneNumberParameter = useSelector(selectAdminPhonesParameter);
  const tokenValidationStatus = useSelector(
    selectBureauFormTokenValidationStatus
  );

  useEffect(() => {
    return () => {
      setStep(1);
    };
  }, []);

  useEffect(() => {
    setLabels(stepperLabels);
  }, [data]);

  const handleNext = useCallback(
    values => {
      setData({ ...data, ...values });
      setStep(step + 1);
    },
    [setStep, step, setData, data]
  );

  const handleNextStep = useCallback(() => {
    setStep(step + 1);
  });

  useEffect(() => {
    if (tokenValidationStatus === 'success') {
      dispatch(loadAdminNumbers());
    }
  }, [tokenValidationStatus]);

  const handleBack = useCallback(() => {
    switch (step) {
      case 1:
        setData(initialState);
        break;
      case 2:
        setStep(step - 1);
        break;
      case 3: {
        setStep(step - 1);
        break;
      }
      default:
        setStep(step - 1);
        break;
    }
  }, [step, setStep]);

  const handleSubmit = useCallback(async values => {
    dispatch(submitBureauForm({ ...values }, handleNextStep));
  });

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingY: '20px'
      }}
    >
      {buroResponse ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: { xs: 'flex-start', md: 'center' },
            width: '80%',
            minHeight: { md: '70vh', xs: 'auto' }
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <ResultBureauView
              name={data.name}
              phones={adminPhoneNumberParameter}
            />
          </Box>
        </Box>
      ) : (
        <>
          <CircularStepper
            activeStep={step}
            steps={labels}
            disableEnumerations
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: { xs: 'flex-start', md: 'center' },
              width: '80%',
              minHeight: { md: '70vh', xs: 'auto' }
            }}
          >
            <CurrentStep
              activeStep={step}
              setStep={setStep}
              data={data}
              onNext={handleNext}
              onBack={handleBack}
              onSubmit={handleSubmit}
            />
          </Box>
        </>
      )}
    </Paper>
  );
};

export default BureauForm;
